package pl.decks.personal.pages.ievp.sections.skills

import pl.decks.personal.components.widgets.ranks.Rank
import pl.decks.personal.components.widgets.ranks.electric.BatteryRank
import pl.decks.personal.components.widgets.ranks.military.ParaMilitaryRank

enum class RankingSystem(val ranks: List<Rank>) {
    PARA_MILITARY(ParaMilitaryRank.entries),
    BATTERY(BatteryRank.entries);

    fun get(slot: Rank.Slot) = ranks.first { it.slot == slot }
}
